var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBnb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0078 7.3522L23.7454 0L36.483 7.3522L31.8 10.0683L23.7454 5.4322L15.6908 10.0683L11.0078 7.3522ZM36.483 16.6244L31.8 13.9083L23.7454 18.5444L15.6908 13.9083L11.0078 16.6244V22.0566L19.0625 26.6926V35.9648L23.7454 38.681L28.4284 35.9648V26.6926L36.483 22.0566V16.6244ZM36.483 31.3288V25.8966L31.8 28.6126V34.0448L36.483 31.3288ZM39.8078 33.2488L31.7532 37.8848V43.317L44.4908 35.9648V21.2604L39.8078 23.9766V33.2488ZM35.125 11.9883L39.8078 14.7044V20.1366L44.4908 17.4205V11.9883L39.8078 9.2722L35.125 11.9883ZM19.0625 39.8518V45.284L23.7454 48L28.4284 45.284V39.8518L23.7454 42.5678L19.0625 39.8518ZM11.0078 31.3288L15.6908 34.0448V28.6126L11.0078 25.8966V31.3288ZM19.0625 11.9883L23.7454 14.7044L28.4284 11.9883L23.7454 9.2722L19.0625 11.9883ZM7.68292 14.7044L12.3659 11.9883L7.68292 9.2722L3 11.9883V17.4205L7.68292 20.1366V14.7044ZM7.68292 23.9766L3 21.2604V35.9648L15.7375 43.317V37.8848L7.68292 33.2488V23.9766Z",
    fill: "#F0B90B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnb);
export default __webpack_public_path__ + "static/media/bnb.c0da2d4c0e1b34d93c4247f9608c2a26.svg";
export { ForwardRef as ReactComponent };